import { storage } from "@gtmhub/core/storage";

export const setCurrentUserId = (id: string): void => storage.set("userId", id);
export const getCurrentUserId = (): string => storage.get("userId");
export const getCurrentAccountId = (): string => storage.get("accountId");
export const getCurrentUserLoginsCount = (): number => storage.get<number>("loginsCount");
